// extracted by mini-css-extract-plugin
module.exports = {"table":"actions-history-modal_table__2vYdP","container":"actions-history-modal_container__3zdbd","modal":"actions-history-modal_modal__I5WZO"};